import {Text, View} from '@react-pdf/renderer';
import {stylesForPdf} from './PdfPostControlStyling';

const formatContracts = (contracts) => {
    if(!contracts || contracts === '') {
        return '-';
    }

    return contracts?.split('') ?? '-';
}

export const renderOrdersTable = (orders) => {
  if (orders?.length > 0) {
      return  <View style={stylesForPdf.orderTable}>
          <View style={stylesForPdf.orderTableHeaderRow} wrap={false}>
              <View style={stylesForPdf.orderTableCell}><Text style={stylesForPdf.verticalCenter}>Numer ogłoszenia o zamówieniu</Text></View>
              <View style={stylesForPdf.orderTableCell}><Text style={stylesForPdf.verticalCenter}>Nazwa zamówienia</Text></View>
              <View style={stylesForPdf.orderTableCell}><Text style={stylesForPdf.verticalCenter}>Kontrakty</Text></View>
          </View>
          {orders.map(o => {
              return  <View style={stylesForPdf.orderTableRow} key={o.uuid} wrap={false}>
                          <View style={stylesForPdf.orderTableCell}><Text>{o.orderNumber?.split('')}</Text></View>
                          <View style={stylesForPdf.orderTableCell}><Text>{o.orderName?.split('')}</Text></View>
                          <View style={stylesForPdf.orderTableCell}><Text>{formatContracts(o.contracts)}</Text></View>
                      </View>
          })}
      </View>
  }
  return null;
};
